
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'сынақ',
	'visualizationSlideoutTitle': 'Көрнекі құралдар',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Санды енгізу',
	'maxValuePlaceholder': 'Санды енгізу',
	'customRangeErrorMessage': 'Мән сан болуы керек',
	'propFillColor': 'Түспен толтыру',
	'propBorderColor': 'Жиек түсі',
	'propColorPalette': 'Ағымдағы түстер бояғышы',
	'propColorPaletteChangeLabel': 'Түсті бояғыштарды өзгерту',
	'propNewColorPaletteLabel': 'Пайдаланушылық түс бояғышты жасаңыз',
	'propNewHeatPaletteLabel': 'Теңшелетін жылу палитрасын жасау',
	'propDonutRadius': 'Сақина радиусы',
	'showTitleLabel': 'Тақырыпты көрсету',
	'titleTypeLabel': 'Тақырып түрі',
	'smartTitleLabel': 'Смарт тақырып',
	'customTitleLabel': 'Өзгермелі тақырып',
	'noTitleLabel': 'Тақырып жоқ',
	'propHeatScalePalette': 'Ағымдағы жылу бояғышы',
	'propHeatPaletteChangeLabel': 'Жылу бояғышын өзгертіңіз',
	'propMaintainAxisScales': 'Білік өлшемін сақтап қалу',
	'propLineAndSymbolColor': 'Сызық және нышан түсі',
	'propLineAndSymbolPalette': 'Сызықтық және символдық түстер палитрасы',
	'propElementColor': 'Элемент түсі',
	'propColumnColor': 'Баған түсі',
	'propColumnPalette': 'Баған түсті бояғыштары',
	'propColumnHeatPalette': 'Бағандық жылу палитрасы',
	'propBarColor': 'Жолақ түсі',
	'propGoalColor': 'Мақсаттық түс',
	'propToColor': 'Бояуға',
	'propFromColor': 'Бояудан',
	'propNumberValidationErrorMessageId': 'Санды енгізу',
	'fontSizeAuto': 'Авто',
	'propAutoBinCount': 'Топтар саны',
	'propAutoBinToggle': 'Автоматты топтау',
	'tabName_general': 'Жалпы',
	'tabName_visDetails': 'Мәліметтер',
	'tabName_animation': 'Анимация',
	'tabName_mediaDetails': 'Мультимедиа мәліметері',
	'tabName_webDetails': 'Веб парақша мәліметтері',
	'tabName_imageDetails': 'Кескін мәліметтері',
	'tabName_visualization': 'Көрнекі бейне',
	'tabName_text': 'Мәтін',
	'sectionName_colorsAndThemes': 'Түс және тақырыптар',
	'sectionName_appearance': 'Пайда болу',
	'sectionName_general': 'Жалпы',
	'sectionName_colorPalette': 'Түс',
	'sectionName_axis': 'Білік',
	'sectionName_axis_label': 'Білік',
	'sectionName_legend': 'Оқиға',
	'sectionName_chart': 'Диаграмма',
	'sectionName_regionLayer': 'Аймақтардың қабаты',
	'sectionName_pointLayer': 'Нүктелер қабаты',
	'sectionName_latLongLayer': 'Ендік/бойлық қабаты',
	'sectionName_pathLayer': 'Жол қабаты',
	'propTransparencyDescription': 'Нысанды ашық немесе мөлдір етіп жасаңыз. 0 және 100 орталығында мәнді енгізіңіс',
	'smart_annotation_unauthorized': 'Аннотациялар: рұқсатсыз кіру',
	'smart_annotation_method': 'Аннотациялар: әдіс рұқсат етілмеді',
	'smart_annotation_media': 'Аннотациялар: ақпарат тасушы түрі рұқсат етілмеді',
	'smart_annotation_input': 'Аннотациялар: енгізу жарамсыз',
	'smart_annotation_internal': 'Аннотациялар: ішкі жүйе қатесі',
	'smart_annotation_generic_error': 'Аннотациялар: қызмет қатесі',
	'smart_annotation_dialog_title': 'Түсініктер',
	'smart_errors': 'Аннотация қателері:',
	'smart_warnings': 'Аннотация туралы ескертулер:',
	'smart_annotation_insight_icon_title': 'Түсініктер',
	'smart_annotations_toggle_on': 'Түсініктемелерді қосыңыз',
	'smart_annotations_toggle_off': 'Түсініктемелерді ажыратыңыз',
	'smart_annotation_insight_unavailable': 'Түсініктер қазіргі уақытта қол жетімді емес',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Жоғарғы немесе Төменгі % сүзгісі қолданылған кезде түсіндірмелер қол жетімді емес',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Жоғары немесе Төменгі % сүзгі қолданылған кезде болжам қол жетімді емес',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Сүзгілер жоғарғы немесе төменгі сүзгі қолданылғанда қол жетімді емес және өрісте бірнеше баған бар',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Болжам жоғарғы немесе төменгі сүзгі қолданылған кезде және өрісте бірнеше баған болса қол жетімді емес',
	'forecast_title': 'Болжам',
	'forecast_toggle_on': 'Болжамдарды қосу',
	'forecast_toggle_off': 'Болжамдарды өшіру',
	'statDetailsPerspectiveTitle': 'Талдау',
	'emptyStatDetailsPanel': 'Ешбір қосымша талдаулар ағымдағы көрнекілік үшін қолжетімді емес.',
	'predict_errors': 'Талдау қателері',
	'predict_warnings': 'Талдау туралы ескертулер',
	'fpd_invalid_data_source': 'Бұл деректер көзінде байланысты смарт-модуль жоқ',
	'fpd_network_issue': 'Бұл деректер көзіне талдау жасауда мәселе пайда болды',
	'fpd_data_source_category': 'Smarts модулі жоқ',
	'fpd_response_errors': 'Ұсынылған драйвер қателері',
	'fpd_response_warnings': 'Ұсынылған жүргізуші туралы ескертулер',
	'catalyst_service_bad_request': 'Жаман сұрау',
	'catalyst_service_unkown_Id': 'Белгісіз сұраныс идентификаторы табылды',
	'catalyst_service_internal_server_error': 'Ішкі сервер қатесі',
	'catalyst_service_generic_error': 'Catalyst қызмет қатесі',
	'catalyst_service_error': 'Бұл қызмет қазір қол жетімді емес',
	'propLegendPosition': 'Мәнді белгілер орналасуы',
	'propLeft': 'Сол',
	'propRight': 'Оң',
	'propTop': 'Үстіңгі',
	'propBottom': 'Төменгі',
	'propNone': 'Ешбір',
	'propLegendDisplay': 'Мәндік белгілерді көрсету',
	'targetThicknessPlaceHolder': '%{min} - %{max} дейін',
	'targetThicknessErrorMsg': 'Толық нөмірді %{min} және %{max} аралығында енгізіңіз.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Драйверлер (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'таңдалған)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Әдепкілерне қайта қою',
	'possibelKeyDriver_AddNewDrivers': 'Қосымша драйверлерді қосыңыз',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Қосымша драйверлерді қосу үшін іздеу',
	'possibleKeyDrivers_MaxPossibleReached': 'Басқаларды қосу немесе таңдау үшін кейбір драйверлерді алып тастаңыз',
	'possibleKeyDrivers_Recommended': 'Ұсынылған',
	'visRecommendedTypes': 'Ұұсынылған көрнекі бейне түрлері',
	'visRecommender_smartsfailure': 'көрнекілендіру туралы ұсыныстар қазір қол жетімді емес',
	'visMore': 'Қосымша...',
	'visMoreTooltip': 'Қосымаща көрнекі бейнелеу',
	'visOtherTypes': 'Өзге көрнекі бейне түрлері',
	'visChange': 'Көрнекі бейнелерді өзгертіңіз',
	'automaticTypeCaption': 'Автоматты',
	'propVisType': 'Көрнекі бейне түрлері',
	'dlg_loading': 'Жүктелуде...',
	'snippetListChartCaption': 'Үзінділер тізімі',
	'convoClusterChartCaption': 'Сөйлесу кластері',
	'areaChartCaption': 'Аймақ',
	'barChartCaption': 'Тақта',
	'columnChartCaption': 'Баған',
	'stackedbarChartCaption': 'Қатталған жолақ',
	'stackedcolumnChartCaption': 'Қатталған баған',
	'bubbleChartCaption': 'Көпіршікті',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Драйверді талдау',
	'scatterChartCaption': 'Нүктелік',
	'lineChartCaption': 'Жол',
	'pointChartCaption': 'Нүкте',
	'heatChartCaption': 'Жылу картасы',
	'bulletChartCaption': 'Таңбалауыш',
	'waterfallChartCaption': 'Сарқырама',
	'pieChartCaption': 'Дөңгелек',
	'mapChartCaption': 'Карта',
	'radialBarChartCaption': 'Радиалды',
	'compositeChartCaption': 'Сызық және баған',
	'wordCloudChartCaption': 'Сөз бұлты',
	'networkChartCaption': 'Желі',
	'relationshipNetworkChartCaption': 'Қатынас желісі',
	'treemapChartCaption': 'Тармақ картасы',
	'packedBubbleChartCaption': 'Бумаланған көпіршік',
	'hierarcicalPackedBubbleChartCaption': 'Иерархия көпіршігі',
	'spiralChartCaption': 'Спираль',
	'decisionTreeChartCaption': 'Шешімдер ағашы',
	'legacyMapChartCaption': 'Бұрынғы карта',
	'sunburstChartCaption': 'Секторлық дөңгелек',
	'visUsageComparison': 'Салыстыру',
	'visUsageRelationships': 'Қатынастар',
	'visUsageTrend': 'Тренд',
	'visUsagePartsToWhole': 'Толық бөліктер',
	'visUsageGeospatial': 'Геокеңістіктік',
	'visUsageAdvanced': 'Жетілдірілген талдаулар',
	'visUsageTablesAndSummary': 'Кестелер және жиынтық',
	'visUsageSocialInsights': 'Әлеуметтік түсініктер',
	'visUsageOther': 'Басқа',
	'autoBinActionText': 'Автоматты топтастыру',
	'filterAutobinActionText': 'Bin -дерді сүзгілеу',
	'memberCalculationActionText': 'Мүше есебі',
	'toolbarActionCalculation': 'Есептеу',
	'toolbarActionEditCalculation': 'Есепті өңдеу',
	'topBottomRankLabel': 'Шен (%{label})',
	'toolbarDeleteFilterActionText': 'Сүзгіш жою',
	'toolbarActionTopKeyDrivers': 'Драйверлерді көрсету',
	'toolbarActionCustomGroup': 'Пайдаланушылар тобы',
	'canNotCreateCustomGroup': 'Бұл пайдаланушы тобын жасай алмаймыз.',
	'aria_label_datatable': 'Дерек кестесі',
	'summaryCaption': 'Жиынтық',
	'MeasuresCaption': 'Көрсеткіштер',
	'MeasuresGroupCaption': 'Көрсеткіштер тобы (%{count})',
	'ValuesCaption': 'Мәндер',
	'turnInsightsOn': 'Түсініктемелерді қосу',
	'turnInsightsOff': 'Түсініктемелерді өшіру',
	'decisionRules': 'Ережелер',
	'decisionTree': 'Ағаш диаграммасы',
	'decisionSunburst': 'Ағаш секторлық дөңгелек диаграммасы',
	'switchToDecisionRules': 'Шешім ережелеріне ауысу',
	'switchToDecisionTree': 'Шешім ағашына ауысу',
	'data_group_less_then': '%{rangeTo} мәнінен кем',
	'data_group_to': '%{rangeFrom} ішіне < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} және жоғары',
	'nullValueContent': '(мәні жоқ)',
	'sum': 'Қосынды',
	'count': 'Есеп',
	'countdistinct': 'Ерекше мәндерді есептеу',
	'avg': 'Орташа',
	'min': 'Ең кіші',
	'max': 'Ең үлкен',
	'automatic': 'Теңшелім',
	'variance': 'Айырмашылық',
	'stddev': 'Стандартты ауытқу',
	'median': 'Медиана',
	'calculated': 'Есептелген',
	'none': 'Ешбір',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'Шақыру сценарийіне қолдау көрсетілмейді.',
	'preAggregateLabel': 'Деректер көзі ішінде жеке мәндерге қолдану',
	'postAggregateLabel': 'Есептегі жол мәндерін қолдану',
	'preAggregateText': 'Ауқым бақылау тақтасының ішінде көрсетілген мәндерді емес, дерек қайнар көзіндегі мәндерді пайдаланады.',
	'defaultAggregation_count': 'Есеп',
	'defaultAggregation_countdistinct': 'Ерекше мәндерді есептеу',
	'defaultAggregation_max': 'Ең үлкен',
	'defaultAggregation_min': 'Ең кіші',
	'defaultAggregation_avg': 'Орташа',
	'defaultAggregation_sum': 'Қосынды',
	'defaultAggregation_auto': 'Авто (%{aggregationType})',
	'keydriver_average': 'Жалпы орта',
	'keydriver_up_down': 'Жоғары не төмен орталармен бөлектелген топтар мақсатқа көп әсер етеді. Әдеттегідей емес жоғары немесе төмен орташа топтарда өте күшті әсер бар.',
	'keydriver_different': 'Бөлектелген топтарда жалпы бөлуден айтарлықтай ерекшеленетін бөлу бар. Бұл топтар мақсатқа көп әсер етеді.',
	'topOperator': 'Үстіңгі',
	'bottomOperator': 'Төменгі',
	'topBottomFact': '%{columnLabel} арқылы %{operator} %{value}%{percent}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Жоғарғы не төменгі санақты жойыңыз',
	'deleteTopBottomPercent': 'Жоғарғы немесе төменгі % жою',
	'topBottomTitle': 'Тек осы нысан',
	'deleteTopBottom': 'Жоғарғы не төменгі санақты жойыңыз',
	'editTopBottom': 'Жоғарғы не төменгі санақты өңдеңіз',
	'editTopBottomCount': 'Жоғарғы не төменгі санақты өңдеңіз',
	'editTopBottomPercent': 'Жоғарғы немесе төменгі % өңдеу',
	'ariaDeleteTopBottomCountLabel': 'Жоғарғы не төменгі санақты жою үшін DELETE пернесін басыңыз.',
	'ariaDeleteTopBottomPercentLabel': 'Жоғарғы немесе төменгі % жою үшін DELETE пернесін басыңыз.',
	'ariaEditTopBottomCountLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'ariaEditTopBottomPercentLabel': 'Жоғарғы немесе төменгі % өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteDrillStateLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'drillUpStateTitle': 'Жоғары жылжу',
	'drillDownStateTitle': 'Төмен жылжу',
	'ariaEditTopBottomLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteTopBottomLabel': 'Жоғарғы не төменгі санақты жою үшін DELETE пернесін басыңыз.',
	'allKeyDriversLabel': 'Авто (барлық драйверлер)',
	'filter_drag_and_drop_single_dock': 'Сүзгілеу үшін бұл жерге деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_all_tabs': 'Барлық қойындыларды сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_current_tab': 'Қойындыны сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_empty_consume_mode': 'Ешбір сүзгі қолданылмаған.',
	'filterClearAllItems': 'Барлық сүзгілерді тазалау',
	'filterDeleteAllItems': 'Барлық сүзгілерді жою',
	'filterDockChevronLeft': 'Деректер бойынша айналдыру',
	'filterDockChevronRight': 'Деректер бойынша айналдыру',
	'filterIconLabel_Single': 'Сүзгілер',
	'filterIconLabel_Global': 'Барлық қойындылар',
	'filterIconLabel_Tab': 'Бұл қойынды',
	'filterIconTooltip_Single': 'Сүзгілер',
	'filterIconTooltip_Global': 'Барлық қойындыларға арналған сүзгілер',
	'filterIconTooltip_Tab': 'Бұл қойындыға арналған сүзгілер',
	'filterDropZoneTooltip_Single': 'Сүзгіні тастау аймағы',
	'filterDropZoneTooltip_Global': 'Барлық қойындылар үшін сүзгіден өткізу аймағы',
	'filterDropZoneTooltip_Tab': 'Бұл қойындының сүзу аймағы',
	'filterOverflowMenu': 'Қосымша',
	'expand': 'Кеңейту',
	'collapse': 'Тасалау',
	'filterDockItemNameAriaLabel': 'Сүзгі тілқатысуын іске қосу және сүзгіні анықтау үшін Enter пернесін басыңыз.',
	'filterItemCanvasMove': 'Кенепке қосу',
	'filterItemDelete': 'Сүзгіні жою',
	'filterInvertRange': 'барлығын қоспағанда: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Кейін емес %{from}',
	'filter_date_after': 'Кейін %{from}',
	'filter_date_before_except': 'Алдында емес %{to}',
	'filter_date_before': 'Алдында %{to}',
	'filter_date_between_except': 'Арасында емес %{from}-%{to}',
	'filter_date_between': 'Арасында %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Барлық',
	'filterExcept': 'қоспағанда %{values}',
	'filterDockToolbarButtonLabel': 'Сүзгіш қондырмасы',
	'navigateTitle': 'Келесіге шарлау',
	'current_nav_group': 'Ағымдағы шарлау тобы - %{navigation_group_name}',
	'next': 'Келесі',
	'previous': 'Алдыңғы',
	'multiselectMsg': '%{count} таңдалды',
	'errMsgFilterItemMissingTitle': '%{itemName} сүзгі мәні(дері) жүктелмейді, себебі бұл мәндер осы деректер жиынымен қол жетімді емес',
	'errMsgFilterItemGenericTitle': 'Сүзгі мәндері \' жүктелмейді',
	'textFilterItemsNotFound': 'Ешбір элемент қолжетімді емес.',
	'nullValueLabel': '(бос)',
	'filterConditionLabel': 'Сүзгілеу шарты',
	'filter_includesAll': 'Барлығын қамтиды',
	'filter_allMembersOfSet': 'Жиындың барлық мүшелері',
	'modelFilter': 'Сүзгі',
	'filtersTitle': 'Сүзгі сипаттары',
	'search': 'Іздеу',
	'clearTextFilterValue': 'Тазалау',
	'invertFilterSelection': 'Оралту',
	'modellingLoading': 'Жүктелуде...',
	'searchAll': 'Барлық бағандарды табыңыз',
	'toolbarActionPossibleKeyDrivers': 'Ауқымды өңдеу',
	'toolbarActionPossibleKeyDriversSubTitle': 'Драйверді талдау кестесінде ескерілетін элементтерді сол жақтан сүйреңіз',
	'toolbarActionSort': 'Сұрыптау',
	'toolbarActionSortAscending': 'Артуы бойынша сұрыптау',
	'toolbarActionSortDescending': 'Кемуі бойынша сұрыптау',
	'toolbarActionSortAuto': 'Авто (%{sortOrder})',
	'toolbarActionSortCustom': 'Теңшелім',
	'toolbarActionFormat': 'Пішім',
	'toolbarActionFormatAbbreviation': 'Аббревиатура',
	'toolbarActionFormatNone': 'Авто',
	'toolbarActionFilter': 'Сүзгі',
	'toolbarActionTopBottom': 'Жоғары немесе төмен',
	'toolbarActionRmvShape': 'Кескінді жою',
	'toolbarActionToggleShapeDrop': 'Инфографика пішіні',
	'toolbarActionToggleShapeDropTitle': 'Инфографика жасау',
	'toolbarActionToggleShapeDropText': 'Инфографика жасау үшін осы өріске арналған пішінді сүйреңіз.',
	'toolbarActionAggregationType': 'Жинақтау',
	'toolbarDeleteActionText': 'Бағанды жою',
	'toolbarTextActionText': 'Мәтін пішімі',
	'toolbarActionFilterLocalKeepSelected': 'Сақтау',
	'toolbarActionFilterLocalExcludeSelected': 'Шығарып тастау',
	'toolbarActionFilterAllKeepSelected': 'Сүзгі',
	'toolbarActionSimpleCalculation': 'Қарапайым есептеулер',
	'toolbarActionDrillBack': 'Артқа',
	'toolbarActionDrillUp': 'Жоғары жылжу',
	'toolbarActionDrillDown': 'Төмен жылжу',
	'toolbarActionNavigate': 'Шарлау',
	'toolbarActionCreateFilterGroup': 'Жаңа байланыс жасау',
	'toolbarActionDisconnectFilterGroup': 'Барлық сілтемелерді бұзу',
	'toolbarActionLinkFilterGroup': 'Бар байланысқа қосу',
	'toolbarActionLassoSelect': 'Құралды таңдау',
	'toolbarActionRefreshDeveloperWidget': 'Жаңарту',
	'textFontFamilySubClassHairline': 'Жұқа сызық',
	'textFontFamilySubClassThin': 'Жіңішке',
	'textFontFamilySubClassThinItalic': 'Жіңішке көлбеу',
	'textFontFamilySubClassExtraLight': 'Қосымша жарық',
	'textFontFamilySubClassExtraLightItalic': 'Қосымша жарық көлбеу',
	'textFontFamilySubClassLight': 'Ашық',
	'textFontFamilySubClassLightItalic': 'Ашық көлбеу',
	'textFontFamilySubClassRegular': 'Қалыпты',
	'textFontFamilySubClassRegularItalic': 'Қалыпты көлбеу',
	'textFontFamilySubClassItalic': 'Көлбеу',
	'textFontFamilySubClassMedium': 'Орташа',
	'textFontFamilySubClassMediumItalic': 'Орташа көлбеу',
	'textFontFamilySubClassHeavy': 'Қалың',
	'textFontFamilySubClassHeavyItalic': 'Қалың көлбеу',
	'textFontFamilySubClassDemiBold': 'Жартылай қалың',
	'textFontFamilySubClassDemiBoldItalic': 'Жартылай қалың көлбеу',
	'textFontFamilySubClassBold': 'Қалың',
	'textFontFamilySubClassBoldItalic': 'Қалың көлбеу',
	'textFontFamilySubClassExtraBold': 'Қосымша қалың',
	'textFontFamilySubClassExtraBoldItalic': 'Қосымша қалың көлбеу',
	'textFontFamilySubClassBlack': 'Қара',
	'textFontFamilySubClassBlackItalic': 'Қара көлбеу',
	'textFontFamilySubClassStencil': 'Трафарет',
	'dlg_ascending': 'Артуы бойынша',
	'dlg_descending': 'Кемуі бойынша',
	'dlg_custom': 'теңшелім',
	'dlg_none': 'Ешбір',
	'dlg_hierarchy': 'иерархия',
	'dlg_namedSet': 'аталған жиын',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Тұтқаны жою',
	'visualizationLabel': 'Көрнекі бейне',
	'chartLabel': '%{chartName} диаграмма',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Виджет арқылы шарлау үшін F12 түймешігін басыңыз',
	'f10KeyDescription': 'Виджеттің меңзеу көрінісін орналастыру үшін F10 түймешігін басыңыз',
	'playButtonLabel': 'Ойнау',
	'dataPlayerValueListLabel': 'Деректер ойнатқышының мәндері',
	'localFilterTitle': 'Тек осы нысан',
	'globalFilterTitle': 'Барлығы нысандар',
	'deleteFilter': 'Сүзгіні жою',
	'editFilter': 'Сүзгіні өңдеу',
	'ariaEditFilterLabel': 'Сүзгіні өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteFilterLabel': 'Сүзгіні жою үшін DELETE пернесін басыңыз.',
	'measureFilterBetween': '%{lowerBound} және %{upperBound} арасында',
	'measureFilterNotBetween': '%{lowerBound} және %{upperBound} арасында емес',
	'dimFilterIn': 'Қамтиды: %{in}',
	'dimFilterNotIn': 'Кірмейді: %{out}',
	'gtFilter': 'Кейін %{lowerBound}',
	'ltFilter': 'Алдында %{upperBound}',
	'ariaEditPrompt': 'ENTER пернесін хабарлу мәнін өзгерту үшін басыңыз',
	'dataPointFilterTitle': 'Деректер нүктелері',
	'dataPointFilterIncludeSummary': '%{valueCount} деректер нүктелеріне қосылды',
	'dataPointFilterExcludeSummary': '%{valueCount} деректер нүстелері шығарылды',
	'widgetFiltersLabel': 'Виджет сүзгілері',
	'coachMarkTitleSpiralTarget': 'Ауқымды өңдеу',
	'coachMarkContentSpiralTarget': 'Мұнда мақсатыңызға арналған драйвер таңдауына кіруге және оны өзгертуге болады.',
	'srILVTreeLabel': 'Тізім',
	'geomapUnrecognizedLocations': 'Таныс емес орналасу орындары:',
	'geomapAmbiguousLocations': 'Мағыналы аймақтар:',
	'visualizationNotifications': 'Көрнекілендіру туралы хабарландырулар:',
	'dataNotifications': 'Деректер туралы хабарландырулар:',
	'autobinSuggestion': 'Автоматты топтауды іске қосу',
	'LIVE_empty_visualization_hint_title': 'Көрнекілігіңізді құру',
	'LIVE_empty_visualization_hint_description': 'Деректерді осы жерге немесе өрістерге сүйреңіз.',
	'LIVE_slots_required_field_description': '%{asterisk} Қажет өрісті көрсетеді',
	'LIVE_slots_drag_and_drop_description': 'Көрнекілікті сүзгілеу және құру үшін өрістерге деректерді сүйреп апарып тастаңыз.',
	'dwErrorLoadingAvailableVisualizations': 'Қолжетімді көрнекі бейне анықтамаларын жүктей алмаймыз',
	'moreDataIndicator': 'Сіздің деректеріңіз %{threshold} элементтері арқылы қиылды. Сүзгіні аз көрсету үшін қабылдаңыз.',
	'nonCtxTopBottomInvalid': 'Жоғары немесе төменгі ережені мәтінмәнсіз анықтауға айқас кестелер үшін қолдау көрсетілмейді. Бұл айқас кесте көрінісінен жойылды.  %{columnName} мәтінмәніндегі бір немесе бірнеше санаттағы ережені қайта анықтаңыз.',
	'dwErrorLoadingVisualizationNotFound': 'Біз нысады жүктей алмаймыз, себебі көрнекілендіру анықтамасы жоқ.',
	'dwErrorLoadingVisualizationListNotFound': 'Көрнекілендіруді жүктей алмаймыз.',
	'dwErrorRunningQuery': '%{datasetName} деректер жиынтығынан деректерді алу мүмкін емес.',
	'dwErrorGeoData': 'Картада географиялық деректерді көрсетудегі қиындықтармен кездестік. Өзге көрнекі бейне түрін таңдауыңызды өтінеміз.',
	'dwPromptSignonCancelWarning': 'Бұл көрсетілімге арналған дерек қол жетімсіз. Дұрыс тіркелгілерді қамтамасыз етіңіз.',
	'dwErrorMissingDataset': 'Көрнекілендіруді жүктей алмаймыз, себебі оның байланысты деректер жиынтығы \'%{datasetName}\' қол жетімді емес.',
	'dwErrorRenderingVisualization': 'Бұл көрнекілендіруді жүктей алмаймыз.',
	'dwErrorVisualizationTooSmall': 'Қамтитын деректерді көрсету үшін көрнекі бейне тым кішкентай. Көрнекі бейнені үлкейтіңіз не құрамындағы деректерге шектеу орнатыңыз.',
	'errorSourceNotFound': 'Көрнекілеуді жүктей алмаймыз, себебі оның байланысты \'%{sourceName}\' көзі қол жетімді емес.',
	'errorActionNotSupported': 'Бұл әрекет \'%{sourceName}\' деректер көзі үшін қолданылмайды.',
	'errorMeasureNotSupportedOnMultiEdges': 'Көрнекілендірудің бірнеше шеттерінде өлшемдер бар, енді ол қолдау көрсетілмейді. Көрсеткіштерді тек бір жиекке қойыңыз.',
	'errorExceedAllowableValue': 'Ұяшықтардың болжамды саны 100000 мәнінен асады. Ұяшықтардың санын азайту үшін сүзгілеуді жобаланған жиындарға қолданыңыз.',
	'propScaleLabel': 'Белгішелер саны',
	'propScaleDescription': 'Белгішелер санын таңдау',
	'propScaleFew': 'Төмен',
	'propScaleDefault': 'Әдепкі',
	'propScaleMany': 'Жоғары',
	'lastRefresh': 'Соңғы жаңарту: %{timeInterval} бұрын',
	'widgetTimer': 'Виджет таймері',
	'datasetItemsUnavailable': 'Бұл көрнекі бейнеде қолданылған кейбір деректер жиыны элементтері қолжетімсіз.',
	'datasetItemUnavailable': 'Бұл деректер жиыны элементі қолжетімсіз',
	'retry': 'Әрекетті қайталау',
	'widgetConditionalFormatLabel': 'Шартты пішім басқаруларын ажырата қосу',
	'widgetConditionalFormatTitle': 'Шартты пішімдеу түсін өңдеңіз',
	'conditionalPalettePickerLabel': '%{title} мәндің таратуы',
	'HistogramYAxisTitle': 'Есеп',
	'crosstabName': 'Қарсы',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'қол жеткізгісіз',
	'summaryLabel': '%{label}  мәнімен %{value}',
	'infographicLabel': '%{label}  мәнімен %{value}',
	'warning': 'Ескерту',
	'swapRowsAndColumns': 'Жолдар мен бағандарды алмастыру',
	'hideSummariesLabel': 'Жиынтықтарды жасыру',
	'showSummariesLabel': 'Жиындарды көрсету',
	'hideRowColumn': 'Жасыру',
	'showAllRowColumn': 'Барлығын көрсету',
	'dataAssetPropertiesLabel': 'Визуалдау сипаттары',
	'evAdd': 'Баған қосу',
	'evCollapse': 'Тасалау',
	'evColumns': 'Бағандар',
	'evLocalFilters': 'Жергілікті сүзгілер',
	'evExpand': 'Кеңейту',
	'evFilterTooltip': 'Сүзгі',
	'missingColumn': 'Жетіспейтін: %{columnLabel}',
	'missingFiltering': 'Бағандарда сүзгілер жоқ:',
	'missingDataItem': 'Сілтеме жасалынған \'%{dataItemId}\' виджетінде табылған жоқ.',
	'heatByLabel': 'Қатынасу жиілігі арқылы',
	'toolbarChangeVisualization': 'Көрнекі бейнелерді өзгертіңіз',
	'modellingRelatedTablesNoneFound': 'Байланысты кестелер табылмады',
	'processing': 'Өңделуде...',
	'errorCellWarning': 'Кейбір жиынтық мәндерді есептеу мүмкін болмады.',
	'aggregateTypeToggler': 'Агрегация түрін көрсетіңіз',
	'maxColumnsExceeded': 'Бағандар саны шегінен асты. %{columns} түсірілді',
	'unboundColumns': 'Келесі бағандарды пайдалану мүмкін емес: %{columns}.',
	'unboundColumn': 'Келесі бағанды пайдалану мүмкін емес: %{columns}.',
	'recommendRequestFailed': 'Ұсыныс сұрауы сәтсіз аяқталды. Әкімшіңізге хабарласыңыз.',
	'visualizationDoesNotSupportOLAP': 'OLAP деректер көзіне негізделген осы көрнекілендіруді жасай алмаймыз. Басқа қолдайтын деректер көзін пайдаланыңыз.',
	'showDataBehindVizLabel': 'Деректерді көрсету',
	'showDataBehindVizNotSupportedLabel': 'Деректерді көрсету бұл көрнекілендіру түріне қолдау көрсетілмейді',
	'exploreData': 'Зерттеу...',
	'newExplore': 'Жаңа зерттеу',
	'thumbnails_error_fetching': 'Эскиздерді алу қатесі',
	'loadedThumbnailImage': 'Көрінекілендіру %{visType} нобай кескіні жүктелді',
	'autobinAxisLabel': 'топтар',
	'recommended_visualizations': 'Ұсынылған көрнекілендірулер',
	'all_visualizations': 'Барлық көрнекі бейнелер',
	'edit': 'Өңдеу',
	'selectTargetDialogTitle': 'Егжей-тегжейлі мақсатты таңдаңыз',
	'noTargetInCM': 'Егжей-тегжейлі мақсатты табу мүмкін емес',
	'errorDrillDefinition': 'Жылжыту бойынша анықтаманы қосқан немесе өңдеген кезде бірдеңе дұрыс болмады.',
	'errorDrillToTarget': '\'%{targetName}\' элементіне жылжытуда қате пайда болды',
	'drillThroughMappingViewLabel': 'Бақылау тақтасындағы бағандарды мақсатты есептің нұсқауларына тағайындаңыз',
	'drillthroughScopeRadioLabel': 'Осы анықтаманы келесіге қолданыңыз:',
	'drillthroughScopeRadioOptionVisualization': 'Бұл көрнекілендіру ғана',
	'drillthroughScopeRadioOptionConnection': 'Дәл сол дерек көзін пайдаланатын қосылымдағы көрнекілендірулер',
	'drillthroughScopeRadioOptionDashboard': 'Бірдей деректер көзін пайдаланатын %{perspective} кез келген көрнекілендіру',
	'drillThroughParametersColumnTitle': '\'%{targetName}\' шақырулары:',
	'drillThroughMetadataColumnTitle': '\'%{boardName}\' деректер бағандары:',
	'drillThroughDefinitionNoParameter': 'Егжей-тегжейлі мақсатты нұсөаулары болмайды.',
	'drillThroughDefinitionErrorQueryingReport': 'Мақсатты есеппен мәселені түзетіп, егжей-тегжейлі анықтаманы жасаңыз.',
	'drillThroughDefinitionErrorDlgTitle': 'Бірдеңе дұрыс емес болды',
	'dlg_back': 'Қайту',
	'dlg_close': 'Жабу',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Болдырмау',
	'dlg_apply': 'Қолдану',
	'drillthrough_unsaveMsg': '\'%{name}\' -ны сақтамай жалғастыру керек пе?',
	'drillthrough_jumpTo': 'Егжей-тегжейлі анықтама: %{name}',
	'drillthrough_jumpToLabel': 'Егжей-тегжейлеу арқылы',
	'drillthrough_manage': 'Басқару...',
	'drillthrough_addNewTarget': 'Жаңа егжей-тегжейлі анықтаманы қосу',
	'drillthrough_manageJumpPaths': 'Егжей-тегжейлі анықтамаларды басқарыңыз',
	'drillthrough_manageJumpPaths_edit': '\'%{name}\' өңдеңіз',
	'drillthrough_manageJumpPaths_delete': '\'%{name}\' жойыңыз',
	'drillthrough_manageAddAnotherTarget': 'Басқа егжей-тегжейлі анықтаманы қосыңыз',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Жоюды растау',
	'drillthrough_manageConfirmeDeleteDrillTarget': '\'%{name}\' егжей-тегжейді жойғыңыз келгеніне сенімдісіз бе?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Қайталанатын егжей-тегжейлі аты',
	'drillthrough_definitionMessage': '\'%{name}\' егжей-тегжейі бұрыннан бар. Басқа атау беріңіз',
	'drillthrough_jumpToTarget_notFound': '\'%{name}\' егжей-тегжейі үшін мақсат табылмады',
	'drillThroughDefinitionNoParameterSubTitle': 'Мақсатты есепке мәтінмән жіберілмейді',
	'drillthrough_titleLabel': 'Тақырып',
	'drillthrough_subTitle': 'Дереккөздегі көрнекі мәтінмән %{perspective} мақсатты сүзу үшін қолданылады.',
	'noPrompt': 'Кеңес хабарлар жоқ',
	'formatAutoDescription': 'Авто деректер көзінен немесе көрнекілендіруден мұраланған пішімді анықтайды.',
	'formatDefaultDescription': 'Әдепкіде жүйеден мұраланған пішім анықталады',
	'createCustomGroupAction': 'Деректер тобын жасау',
	'removeCustomGroupAction': 'Деректер тобын жою',
	'editCustomGroupAction': 'Деректер тобын өңдеу',
	'renameCustomGroupAction': 'Деректер тобын қайта атаңыз',
	'createCustomGroupErrorToast': 'Сіздің деректер тобыңызды жасау мүмкін емес.',
	'removeCustomGroupErrorToast': 'Сіздің деректер тобыңызды жою мүмкін емес.',
	'editCustomGroupErrorToast': 'Сіздің деректер тобыңызды өзгерту мүмкін емес.',
	'renameCustomGroupErrorToast': 'Деректер тобын қайта атау мүмкін болмады.',
	'customGroupLabel': 'Деректер тобы',
	'ungroupCustomGroupLabel': 'Топтамау',
	'renameCustomGroupLabel': 'Атын өзгерту',
	'createCustomGroupLabel': 'Жасау',
	'customGroupingLabel': '%{columnLabel} (Топ)',
	'createCustomSort': 'Пайдаланушылық сұрыптауды жасаңыз',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Қолжетімді элементтерді таңдап, оларды пайдаланушылық сұрыптауды жасау үшін қайта реттеңіз.',
	'availableItems': 'Қолжетімді элементтер',
	'selectAll': '(Барлығын таңдау)',
	'customSortOrder': 'Пайдаланушылық сұрыптау реті',
	'selectAvailableItemsDesc': 'Қол жетімді элементтерді таңдап, оларды осында қайта реттеңіз.',
	'moveToTop': 'Жоғарырақ жылжыту',
	'clear': 'Тазалау',
	'sortRemainingItemsBy': 'Басқа элементтерді сұрыптау',
	'clearAll': 'Барлығын тазалау',
	'resetTooltip': 'Барлық элементтер %{customSortOrder} тізімінен жойылады. Және %{sortRemainingItemsBy} ашылмалысы әдепкіше қайтарады.',
	'manyItemsWarning': 'Көптеген элементтерді таңдау сіздің бақылау тақтаңыздың жұмысына әсер етуі мүмкін.',
	'manyItemsSelected': '%{maxItems} элементтерінен артық таңдалған, бұл сіздің бақылау тақтаңыздың жұмысына әсер етуі мүмкін.',
	'somethingWentWrong': 'Бірдеңе дұрыс емес болды',
	'unableToLoadItems': 'Қол жетімді элементтерді жүктеу мүмкін емес.',
	'tryAgain': 'Әрекетті қайталау',
	'customSortLabel': 'Теңшелетін сұрыптау',
	'applyError': '%{action} қолдану мүмкін емес.',
	'searchReturnedNoResults': 'Іздеуіңіз еш нәтижесіз',
	'tryDifferentSearchTerm': 'Басқа іздеу терминін қарап көріңіз',
	'extVisSystem': 'Жүйе',
	'extVisCustom': 'Теңшелім',
	'customVisTestVisualization': 'Тексеру көрнекілендіруі',
	'extVisCustomVisPreview': 'алдын ала көріп алу',
	'extVisCustomPreviewWidgets': 'Әзірлеуші виджеттері',
	'extVisCustomVVisualization': 'Көрнекі бейне',
	'extVisCustomVisuals': 'Теңшелетін көрнекі құралдар',
	'noPermissionToManage': 'Теңшелетін көрнекілендіруді басқаруға рұқсатыңыз жоқ.',
	'extVisCustomUpdate': 'Жаңарту',
	'extVisCustomDelete': 'Жою',
	'extVisNoCustomVisuals': 'Теңшелетін көрнекілендірулер жоқ',
	'extVisNoCustomVisualsMsg': 'Қазіргі уақытта ұйымыңызда теңшелетін көрнекілендірулер жоқ',
	'extVisAddCustomVisual': 'Теңшелетін көрнекілендіруді қосу',
	'extVisNoCustomVisualsAdminMsg': 'Қазіргі уақытта теңшелетін көрнекілендірулер жоқ. Жұмысты бастау үшін біреуін қосыңыз',
	'extVisNoSDKConnection': 'Жергілікті файлыңызға байланыс орнатылмады',
	'extVisNoSDKPreviewMsg': 'Көрнекіленуді алдын-ала көру үшін байланыс орнатыңыз.',
	'extVisMore': 'Қосымша',
	'extVisDeleteDialogTitle': 'Теңшелетін көрнекілендіруді жою',
	'extVisDeleteDialogBody': 'Осы теңшелетін көрнекілендіруді жойғыңыз келе ме? Бұл басқа да бақылау тақталары мен есептермен қолданылуы мүмкін.',
	'extVisDeleteConfirmation': 'Теңшелетін көрнекілендіруіңіз жойылды.',
	'extVisDeleteError': 'Сіздің теңшелетін көрнекілендіруіңізді жою мүмкін емес. %{msg}',
	'extVisCloseToast': 'Қазір жабыңыз',
	'extVisAdd': 'Сіздің теңшелетін көрнекілендіруңіз сәтті қосылды.',
	'extVisAddError': 'Сіздің теңшелетін көрнекілендіруңізді қосуға болмады. %{msg}',
	'extVisUpdate': 'Сіздің теңшелетін көрнекілендіруңіз сәтті жаңартылды.',
	'extVisUpdateError': 'Сіздің теңшелетін көрнекілендіруңізді жаңарту мүмкін емес. %{msg}',
	'extVisAddProgress': '%{name} импорттау',
	'extVisUpdateProgress': '%{name} жаңарту',
	'extPermissionTitle': 'Шектеулі қатынас немесе жойылған теңшелетін көрнекілендіру',
	'extPermissionBody': 'Бұл теңшелетін көрнекілендіруді қарау мүмкін емес, себебі ол жойылған немесе кіруге шектеу қойылған.',
	'customVizSaveWarning': 'Теңшелетін көрнекілерді сақтау мүмкін емес. Олар импорталған жоқ.',
	'schematicTestCaption': 'Тексеру схемасы',
	'schematicServiceRequestError': 'Қызметтік схема қатесі',
	'extVisPreviewMessage': 'Бұл алдын ала қарау. Көрнекілендіру әлі өнімге қосылмаған.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Анықталмаған',
	'kpiDefaultTargetLabel': 'Мақсаты',
	'kpiNonNumericTarget': 'Мақсатты мән сан болуы керек.',
	'kpiManualTargetSlotFilled': 'Өрісне қолданылатын мән',
	'kpiAutoValueSize': 'Авто',
	'kpiUnableDrawSparklineLabel': 'Спарклайнды сызу мүмкін емес',
	'kpiUnableDrawSparklineInfo': 'Спарклайн ең аз дегенде екі нүктені қажет етеді. Спарклайн көру үшін деректерді өзгертіңіз немесе сүзгілерді реттеңіз.',
	'conditionalFormattingEnabled': 'Шартты түс',
	'currentConditionalPalette': 'Ағымдағы шартты бояғыш',
	'sectionName_range': 'Ауқымды орнату',
	'rangeScaleLabel': 'Масштабтау',
	'rangeScalePercentage': 'Пайызы',
	'rangeScaleNumeric': 'Сандық',
	'numberOfSteps': 'Ауқым саны',
	'conditionalFormattingSelectedStep': 'Таңдалған ауқым',
	'conditionalFormattingStartValue': 'Бастау мәні',
	'conditionalFormattingEndValue': 'Соңғы мәні',
	'conditionalFormattingTextColor': 'Мәтін түсі',
	'conditionalFormattingMin': 'мин',
	'conditionalFormattingMax': 'Ең жоғары',
	'conditionalFormattingNonNumericValue': 'Мән сан болуы керек.',
	'conditionalFormattingStepIndexInvalid': 'Ауқым индексі жарамсыз.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'Мән %{start} - %{end} ауқымында болуы керек.',
	'conditionalFormattingValueShouldBeLower': 'Мәннің %{value} параметрінен аз немесе оған тең болуы қажет.',
	'conditionalFormattingValueSouldBeHigher': 'Мәннің %{value} параметрінен артығырақ немесе оған тең болуы қажет.',
	'conditionalFormattingDeleteStep': 'Таңдалған ауқымды алып тастаңыз',
	'conditionalFormattingRestoreSteps': 'Ауқымдарды қалпына келтіріңіз',
	'conditionalFormattingReversePalette': 'Кері түстері',
	'conditionalFormattingShapeIndicator': 'Көрсеткіш пішіні',
	'conditionalFormattingIconNone': 'Пішіні жоқ',
	'conditionalFormattingIconArrowUp': 'Жоғарғы көрсеткі',
	'conditionalFormattingIconArrowRight': 'Оң жақ көрсеткі',
	'conditionalFormattingIconArrowDown': 'Төменгі көрсеткі',
	'conditionalFormattingIconCaretUp': 'Жоғарыға енгізу белгісі',
	'conditionalFormattingIconDash': 'Тире',
	'conditionalFormattingIconCaretDown': 'Төменге енгізу белгісі',
	'conditionalFormattingIconCheckmark': 'Тексеру белгісі',
	'conditionalFormattingIconWarning': 'Ескерту',
	'conditionalFormattingIconXSymbol': 'X таңбасы',
	'conditionalFormattingIconCircle': 'Шеңбер',
	'conditionalFormattingIconTriangle': 'Үшбұрыш',
	'conditionalFormattingIconDiamond': 'Гауһар тас',
	'conditionalFormattingIconFaceSatisfied': 'Риза болған бет',
	'conditionalFormattingIconFaceNeutral': 'Бейтарап бет',
	'conditionalFormattingIconFaceDissatisfied': 'Риза емес бет',
	'suppression': 'Басу',
	'suppressNone': 'Ешбір',
	'suppressRowsAndColumns': 'Жолдар және бағандар',
	'suppressRows': 'Жолдар',
	'suppressColumns': 'Бағандар',
	'enableSuppression': 'Басуды қосу',
	'disableSuppression': 'Басуды ажырату',
	'loadVisDefinitionError': 'Көрнекілендіру үшін анықтаманы жүктеу мүмкін болмады %{id}',
	'emptyVisualization': 'Бос көрнекілендіру',
	'expandCollapse': 'Кеңейту және тасалау',
	'expandBtnLabel': 'Кеңейту',
	'collapseBtnLabel': 'Тасалау',
	'prop_sizeInputNonNumericValue': 'Мән сан болуы керек.',
	'prop_sizeValueShouldBeHigher': 'Мәннің %{value} параметрінен артығырақ болу қажет.',
	'fontPropLabel': 'Қаріп жиынтығы',
	'fontSizePropLabel': 'Қаріп өлшемі',
	'sectionItemAxisTitle': 'Элемент осінің тақырыбы',
	'sectionItemAxisLabel': 'Элемент осінің белгісі',
	'sectionValueAxisTitle': 'Мән осінің тақырыбы',
	'sectionValueAxisLabel': 'Мән осінің белгісі',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Көрнекі бейне',
	'ds-missingDataSet': 'Could not find dataset. Please make sure dataset is created successfully.',
	'ds-missingDashboardId': 'Деректер қорын жасамас бұрын бақылау тақтасын сақтаңыз.',
	'ds-unsupportedDataSourceType': '%{type} деректер көзі түріне қолдау көрсетілмейді.'
});
